import React from 'react';
import {
  LandingNav,
  HeroSection,
  AudienceSection,
  FeaturesSection,
  PricingSection,
  FeatureComparisonSection,
  FAQSection,
  EnterpriseCTASection,
  FooterSection,
} from '../components/landing';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <LandingNav />
      <HeroSection />
      <AudienceSection />
      <FeaturesSection />
      <PricingSection />
      <FeatureComparisonSection />
      <EnterpriseCTASection />
      <FAQSection />
      <FooterSection />
    </div>
  );
};

export default LandingPage;
